/**
 * 域名管理器（Web版）— 基于当前部署域名动态获取后端地址
 * 不再依赖远程 JSON 配置，API 使用相对路径（自动跟随当前域名），
 * WebSocket 基于 window.location 动态拼接绝对 wss:// 地址。
 * 部署到任意域名，都会自动连接该域名的 /api 与 /im。
 */

// 相对 API 前缀（HTTP 用）
const API_PREFIX = '/api'
// WebSocket 路径前缀
const WS_PATH = '/im'

// 触发域名切换的错误状态码（保留接口兼容，单域名部署下不实际切换）
const SWITCHABLE_STATUS = new Set([404, 408, 500, 502, 503, 504])

class DomainManager {
  constructor() {
    this.initialized = true
    this.domains = []
    this.currentIndex = 0
    this.failCounts = []
    this.switches = 0
  }

  async init() {
    // 本地相对域名，无需远程拉取
    this.initialized = true
  }

  /** 获取当前域名配置（兼容旧接口） */
  getCurrent() {
    return null
  }

  /** 切换到下一个可用域名（单域名部署无备用域名，返回 false） */
  switchToNext() {
    return false
  }

  /** 标记当前域名一次成功请求 */
  reportSuccess() {
    this.failCounts[this.currentIndex] = 0
    this.switches = 0
  }

  /**
   * 上报一次「可切换类」失败。
   * 单域名部署下不再切换，返回 true 表示留在当前域名重试（给瞬时故障恢复机会）。
   */
  reportFailure() {
    return true
  }

  /** 等待就绪（本地地址立即就绪） */
  async ready() {
    return this
  }

  /** 获取当前 API Base URL：相对路径 /api（自动跟随当前部署域名） */
  getBaseUrl() {
    return API_PREFIX
  }

  /** 获取当前 WebSocket URL：wss://当前域名/im（WebSocket 必须绝对地址） */
  getWsUrl() {
    const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:'
    return protocol + '//' + window.location.host + WS_PATH
  }

  /** 判断某 HTTP 状态码是否应触发域名切换（保留接口兼容） */
  isSwitchableStatus(status) {
    return SWITCHABLE_STATUS.has(status)
  }

  /** 可用域名数量（本地固定为 1） */
  getCount() {
    return 1
  }

  /** 获取当前域名的协议页URL */
  getProtocolUrl() {
    return this.extractOrigin() + '/protocol/yh.html'
  }

  /** 获取当前域名的隐私页URL */
  getPrivacyUrl() {
    return this.extractOrigin() + '/protocol/ys.html'
  }

  /** 获取当前域名的扫码跳转URL */
  getScanUrl() {
    return this.extractOrigin() + '/h5'
  }

  /** 从当前地址提取协议+域名部分 */
  extractOrigin() {
    return window.location.protocol + '//' + window.location.host
  }
}

const domainManager = new DomainManager()
export default domainManager
